import { BsModalRef } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { OrderTypeComponent } from './order-type.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from './order-type.routing';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '@app/pipes/pipes.module';
@NgModule({
    imports: [
        CommonModule,
        routing,
        FormsModule,
        AccordionModule.forRoot(),
        PipesModule
    ],
    declarations: [
        OrderTypeComponent 
    ],
    exports: [
    ],
    providers:[
        BsModalRef
    ]
})

export class OrderTypeModule {}
